import SigninImg1 from "../assets/images/gif/signinImg1.gif";
import SigninImg2 from "../assets/images/gif/signinImg2.gif";

const Gif = {
    SigninImg1,
    SigninImg2,   
};

export default Gif;
